import React from "react";
import { useThemeContext } from "../../context/themeContext";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { ReactComponent as EmptyIconDark } from "../../assets/IconEmptyDark.svg";
import { ReactComponent as EmptyIconLight } from "../../assets/IconEmptyLight.svg";

// Copy keyed by feed scope. The "everyone" feed is global so there's nothing to act
// on but wait; the "following" feed prompts the user to go find people to follow.
const VARIANT_CONFIG = {
  noActivities: {
    message: "Nothing to show yet! Check back soon",
    showAction: false,
  },
  noFollowers: {
    message:
      "Nothing to show yet! Follow people to see what they've been watching, reading and curating",
    showAction: true,
  },
};

export default function EmptyActivity({ onOpenUserSearch, variant }) {
  const { mode } = useThemeContext();
  const { message, showAction } =
    VARIANT_CONFIG[variant] ?? VARIANT_CONFIG.noActivities;
  return (
    <Card
      sx={{
        width: "100%",
        mb: 2,
        boxShadow: "none",
        bgcolor: (theme) =>
          mode === "dark"
            ? theme.palette.background.paper
            : theme.palette.secondary.main,
      }}
    >
      <CardContent sx={{ pb: 0 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems="center"
          // justifyContent={{ xs: "center", md: "flex-start" }}
          justifyContent="center"
          spacing={{ xs: 0, sm: 2 }}
        >
          <SvgIcon
            sx={{
              width: 100,
              height: 100,
              color: "primary.main",
            }}
          >
            {mode === "dark" ? <EmptyIconDark /> : <EmptyIconLight />}
          </SvgIcon>
          <Typography textAlign={{ xs: "center", sm: "left" }}>
            {message}
          </Typography>
        </Stack>
      </CardContent>
      {showAction && (
        <CardActions sx={{ justifyContent: "flex-end", mt: { xs: 1, sm: 0 } }}>
          <Button onClick={onOpenUserSearch}>Find people to follow</Button>
        </CardActions>
      )}
    </Card>
  );
}
